export default class Utils {
  static setInterval(funcao, timeout) {
    return setInterval(funcao, timeout);
  }
}
